import React from 'react';

import ImageAvatar from 'ui/image/image-avatar';

import styles from './auto-complete.scss';

type Props = {
  hideImages?: boolean,
  highlight?: boolean,
  i: any,
  mapping?: Object,
  onSelect?: string => void
};

function renderIcon(icon) {
  if (React.isValidElement(icon)) return <div className={styles.fieldIcon}>{icon}</div>;
  else return <ImageAvatar small className={styles.fieldIcon} image={icon} />;
}

const ListElement = ({ hideImages, highlight, i, mapping, onSelect }: Props) => (
  <div
    key={i[mapping.text]}
    className={styles.listElement + ' row v-center' + (highlight ? styles.highlight : '')}
    onMouseDown={() => onSelect(i)}
  >
    {!hideImages && (
      <div style={{ width: 48, minWidth: 48, height: 48, marginRight: 10 }}>
        {i[mapping.image] && renderIcon(i[mapping.image])}
      </div>
    )}

    <div style={{ marginTop: 'auto', marginBottom: 'auto', width: '100%' }}>
      <span>{i[mapping.text] || i.value}</span>
      <br />
      {i[mapping.faded] && <span className="text-fade">{i[mapping.faded]}</span>}
    </div>
  </div>
);

export default ListElement;
